<template>
  <vx-card class="p-4" style="width: 100%">
    <template slot="no-body">
      <vx-input-group>
        <template slot="prepend">
          <div class="prepend-text bg-primary">
            <span>Meu Link</span>
          </div>
        </template>

        <vs-input
          v-model="meuLink"
          id="Link da Loja"
          name="Link da Loja"
          readonly
        />
        <template slot="append">
          <vs-button
            v-tooltip="'Copiar'"
            color="primary"
            type="gradient"
            icon-pack="feather"
            icon="icon-copy"
            class="d-inline"
            @click="copiarMeuLink()"
          ></vs-button>
        </template>
      </vx-input-group>
    </template>
  </vx-card>
</template>

<script>
import jwt from 'jsonwebtoken';

export default {
  data() {
    return {
      meuLink: '',
    };
  },
  methods: {
    copiarMeuLink() {
      //O texto que será copiado
      const texto = this.meuLink;
      //Cria um elemento input (pode ser um textarea)
      let inputTest = document.createElement('input');
      inputTest.value = texto;
      //Anexa o elemento ao body
      document.body.appendChild(inputTest);
      //seleciona todo o texto do elemento
      inputTest.select();
      //executa o comando copy
      //aqui é feito o ato de copiar para a area de trabalho com base na seleção
      document.execCommand('copy');
      //remove o elemento
      document.body.removeChild(inputTest);
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: 'Seu Link foi copiado para a área de Transfêrencia',
        color: 'success',
        time: 5000,
      });
    },
    openDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);

        this.meuLink = `${window.location.origin.replace(
          'app',
          'adm',
        )}/novaProposta/${this.decoded.id_empresa}/${this.decoded.userName}`;
      }
    },
  },
  created() {
    this.openDecoded();
  },
};
</script>
